module.exports = __webpack_public_path__ + "static/media/logo-combine.9ed510ce.png";